// extracted by mini-css-extract-plugin
export default {"abnormalSummary":"questionnaireSurveyTotal_abnormalSummary__QDKhK"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"abnormalSummary\":\"questionnaireSurveyTotal_abnormalSummary__QDKhK\"}";
        // 1793842501118
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  